const ded = [
    `<h2> Please, confirm your <span class="green-text">email</span></h2>`,
    `Open your email and find an email from <span class="green-text">support@dressdown.me</span> and subject: Activate your account | <span class="green-text">D</span>ressdown`,
    `If the email didn’t arrive in 2 mins, please, check Spam (or PromoIon folder in gmail)`,
];

export default ded
